const compiledRegex = new Map<string, RegExp>();

export const replacePatternXWhenWrappedInPatternY =
  (x: string, y: string, replacementForX: string) =>
  (input: string): string => {
    const regexStr = `(${y})${x}(${y})`;
    if (!compiledRegex.has(regexStr)) {
      compiledRegex.set(regexStr, new RegExp(regexStr, "ug"));
    }
    const regex = compiledRegex.get(regexStr)!;

    return input.replace(regex, `$1${replacementForX}$2`);
  };
